/**
 * Subtracts 'days' amount of days from given date object
 * @param {*} date 
 * @param {*} days 
 * @returns
 */
export function dateMinusDays(date, days) {
    let compareDate = date
    return new Date(compareDate.setDate(compareDate.getDate() - days))
}

export function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => { func.apply(this, args) }, timeout)
    }
}

// dec2hex :: Integer -> String
// i.e. 0-255 -> '00'-'ff'
function dec2hex(dec) {
    return dec.toString(16).padStart(2, "0")
}

// generateId :: Integer -> String
/**
 * https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
 * @param {*} len 
 * @returns Random string of characters
 */
export function generateId(len = 40) {
    var arr = new Uint8Array((len || 40) / 2)
    window.crypto.getRandomValues(arr)
    return Array.from(arr, dec2hex).join('')
}